import definitions from "../../definitions";
import ActorCampfire from "./ActorCampfire";

export default class ActorFactory {
    /**
     * @param {string} id
     * @returns {Actor}
     */
    static create(id) {
        switch (id) {
            case definitions.ACTOR_ID.CAMPFIRE: {
                return new ActorCampfire();
            }
        }
        return null;
    }
}